































































// decoradores
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { TipoDocumento } from "@/typings/store/plugins/easyFirestore/tipoDocumentos";
import SVGIcon from "@/components/SVGIcon.vue";
// tipos

// tipos
@Component({
  components: {
    SVGIcon,
  },
})
export default class InfoTipoDocumento extends Vue {
  @Prop() readonly tipoDocumento!: TipoDocumento;
  @Prop({ type: Boolean }) readonly showTitulo!: boolean;

  get id(): string {
    return this.tipoDocumento.id || "N/R";
  }

  get nombre(): string {
    return this.tipoDocumento.nombre || "N/R";
  }

  get posicion(): string {
    return this.tipoDocumento.posicion || "N/R";
  }


  @Emit("cerrar")
  onCerrar(): void {
    return;
  }
}
